import TimingTest from './TimingTest'

export default TimingTest